import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store'

const selectUIState = (state: RootState) => state.ui

export const selectUIDrawer = createSelector(selectUIState, (state) => state.drawer)
